import {defineMessages} from 'react-intl';

export default defineMessages({
  changingLanguageMessage: {
    defaultMessage: 'Changing language...',
    id: 'Footer.FooterChangingLanguageOverlay.ChangingLanguageMessage',
  },
});
